<template>
  <div class="selectPop">
    <el-tabs v-model="cssActiveName" v-if="popKey === 'kqjcFocus'">
      <el-tab-pane label="牙周" name="1">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.yazhou" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="舌腭腺" name="2">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.sheexian" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="颞颌面" name="3">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.ehemian" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="淋巴结" name="4">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.linbajie" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-tabs v-model="cssActiveName" v-if="popKey === 'cssFocus'">
      <el-tab-pane label="围产情况" name="1">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.wcqk" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="出生情况" name="2">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.csqk" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'yazhou-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'yazhou-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                 <div v-else :key="'yazhou-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="content" v-if="popKey === 'tgjcFocus' && 0">
      <div class="rowBox" v-for="(item,index) in dataList.tz" :key="index">
        <div class="rowItem" v-for="(items,index) in item" :key="index">
          <div class="itemBox">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    体重-->
    <div class="manyContent" v-if="popKey === 'tzFocus'">
      <div class="leftContent">
        <div @click="tizhongLeftBarActive = '1'" :class="tizhongLeftBarActive === '1'?'contentItemactive':'contentItem'">婴儿童(2~32)</div>
        <div @click="tizhongLeftBarActive = '2'" :class="tizhongLeftBarActive === '2'?'contentItemactive':'contentItem'">青少年(30~60)</div>
        <div @click="tizhongLeftBarActive = '3'" :class="tizhongLeftBarActive === '3'?'contentItemactive':'contentItem'">成年人(45~100)</div>
      </div>
      <div class="content">
        <div class="rowBox" v-for="(item,index) in getTizhongShow()" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        kg
      </div>
    </div>
<!--    身高-->
    <div class="manyContent" v-if="popKey === 'sgFocus'">
      <div class="leftContent">
        <div @click="shengaoLeftBarActive = '1'" :class="shengaoLeftBarActive === '1'?'contentItemactive':'contentItem'">婴儿童(45~100)</div>
        <div @click="shengaoLeftBarActive = '2'" :class="shengaoLeftBarActive === '2'?'contentItemactive':'contentItem'">青少年(100~150)</div>
        <div @click="shengaoLeftBarActive = '3'" :class="shengaoLeftBarActive === '3'?'contentItemactive':'contentItem'">成年人(150~200)</div>
      </div>
      <div class="content">
        <div class="rowBox" v-for="(item,index) in getShengaoShow()" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        cm
      </div>
    </div>
<!--    体温-->
      <div class="manyContent" v-if="popKey === 'tiwenFocus'">
        <div class="content">
          <div class="rowBox" v-for="(item,index) in dataList.tw" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
              <div class="itemList" :class="{'no-title': !items.typeTitle}">
                <template v-for="(itemss,indexss) in items.list">
                  <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                  <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 当itemss为'|'时，也插入一个换行符 -->
                  <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                  <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                  <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="rightContent">
          °C
        </div>
      </div>
    <!--脉搏-->
    <div class="manyContent" v-if="popKey === 'maiboFocus'">
      <div class="content">
        <div class="rowBox" v-for="(item,index) in dataList.mb" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        bpm
      </div>
    </div>
<!--    呼吸-->
    <div class="manyContent" v-if="popKey === 'huxiFocus'">
      <div class="content">
        <div class="rowBox" v-for="(item,index) in dataList.hx" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        次/分
      </div>
    </div>
<!--    血压-->
    <div class="manyContent" v-if="popKey === 'xueyaFocus'">
      <div class="content">
        <div class="rowBox" v-for="(item,index) in dataList.xy" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        mmHg
      </div>
    </div>
<!--  血氧  -->
    <div class="manyContent" v-if="popKey === 'xueyangFocus'">
      <div class="content">
        <div class="rowBox" v-for="(item,index) in dataList.xueyang" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        %
      </div>
    </div>
<!--    血糖-->
    <div class="manyContent" v-if="popKey === 'xuetangFocus'">
      <div class="content">
        <div class="rowBox" v-for="(item,index) in dataList.xuetang" :key="index">
          <div class="rowItem" v-for="(items,index) in item" :key="index">
            <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
            <div class="itemList" :class="{'no-title': !items.typeTitle}">
              <template v-for="(itemss,indexss) in items.list">
                <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                <!-- 当itemss为'|'时，也插入一个换行符 -->
                <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        mmol/L
      </div>
    </div>
    <el-tabs v-model="cssActiveName" v-if="popKey === 'tgjcFocus'">
      <el-tab-pane label="体征" name="1">
        <div class="content" >
          <div class="rowBox" v-for="(item,index) in dataList.tz" :key="index">
            <div class="rowItem" v-for="(items,index) in item" :key="index">
              <div class="itemBox">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
              </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="体温" name="2">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.tw" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            °C
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="脉搏" name="3">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.mb" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            bpm
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="呼吸" name="4">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.hx" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            次/分
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="血压" name="5">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.xy" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            mmHg
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="体重" name="6">
        <div class="manyContent">
          <div class="leftContent">
            <div @click="tizhongLeftBarActive = '1'" :class="tizhongLeftBarActive === '1'?'contentItemactive':'contentItem'">婴儿童(2~32)</div>
            <div @click="tizhongLeftBarActive = '2'" :class="tizhongLeftBarActive === '2'?'contentItemactive':'contentItem'">青少年(30~60)</div>
            <div @click="tizhongLeftBarActive = '3'" :class="tizhongLeftBarActive === '3'?'contentItemactive':'contentItem'">成年人(45~100)</div>
          </div>
          <div class="content">
            <div class="rowBox" v-for="(item,index) in getTizhongShow()" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            kg
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="身高" name="7">
        <div class="manyContent">
          <div class="leftContent">
            <div @click="shengaoLeftBarActive = '1'" :class="shengaoLeftBarActive === '1'?'contentItemactive':'contentItem'">婴儿童(45~100)</div>
            <div @click="shengaoLeftBarActive = '2'" :class="shengaoLeftBarActive === '2'?'contentItemactive':'contentItem'">青少年(100~150)</div>
            <div @click="shengaoLeftBarActive = '3'" :class="shengaoLeftBarActive === '3'?'contentItemactive':'contentItem'">成年人(150~200)</div>
          </div>
          <div class="content">
            <div class="rowBox" v-for="(item,index) in getShengaoShow()" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            cm
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="血氧" name="8">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.xueyang" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            %
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="血糖" name="9">
        <div class="manyContent">
          <div class="content">
            <div class="rowBox" v-for="(item,index) in dataList.xuetang" :key="index">
              <div class="rowItem" v-for="(items,index) in item" :key="index">
                <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
                <div class="itemList" :class="{'no-title': !items.typeTitle}">
                  <template v-for="(itemss,indexss) in items.list">
                    <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
                    <div v-if="itemss === 'p'" :key="'tz-br-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 当itemss为'|'时，也插入一个换行符 -->
                    <div v-else-if="itemss === '|'" :key="'tz-divider-'+index+'-'+indexss" class="line-break"></div>
                    <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
                   <div v-else :key="'tz-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="rightContent">
            mmol/L
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="content" v-if="popKey !== 'kqjcFocus' && popKey !== 'cssFocus' && popKey !== 'tgjcFocus'">
      <div class="rowBox" v-for="(item,index) in dataList" :key="index">
        <div class="rowItem" v-for="(items,index) in item" :key="index">
          <div class="itemTitle" v-if="items.typeTitle">{{items.typeTitle}}</div>
          <div class="itemList" :class="{'no-title': !items.typeTitle}">
            <template v-for="(itemss,indexss) in items.list" @click="setValue(itemss)">
              <!-- 当itemss为'p'时，插入一个换行符并显示内容 -->
              <div v-if="itemss === 'p'" :key="'general-br-'+index+'-'+indexss" class="line-break"></div>
              <!-- 当itemss为'|'时，也插入一个换行符 -->
              <div v-else-if="itemss === '|'" :key="'general-divider-'+index+'-'+indexss" class="line-break"></div>
              <!-- 否则显示正常内容，根据itemss是对象还是字符串显示不同内容 -->
              <div v-else :key="'general-'+index+'-'+indexss" class="items" :class="{highlight: isItemInInputValue(itemss)}" @click="setValue(itemss)">{{typeof itemss === 'object' ? itemss.label : itemss}}</div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="closeBtn" @click="close()">
      <i class="el-icon-circle-close"></i>
      <div class="text">
      关闭
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['dataList','popKey','inputValue'],
  name: "selectPop",
  data() {
    return {
      cssActiveName: '1',
      tizhongLeftBarActive: '1',
      shengaoLeftBarActive: '1',
    }
  },
  methods: {
    setValue (val) {
      if (typeof val === 'string') {
        console.log(val)
        this.$emit('getValue',{value: val,popKey:this.popKey})
      } else {
        this.$emit('getValue',{value: val.value,popKey:this.popKey})
        console.log(val.value)
      }
    },
    close () {
      this.$emit('close', this.popKey)
    },
    getTizhongShow () {
      if (this.tizhongLeftBarActive === '1') {
        return this.dataList.tizhong1
      } else if (this.tizhongLeftBarActive === '2') {
        return this.dataList.tizhong2
      } else if (this.tizhongLeftBarActive === '3') {
        return this.dataList.tizhong3
      }
    },
    getShengaoShow () {
      if (this.shengaoLeftBarActive === '1') {
        return this.dataList.shengao1
      } else if (this.shengaoLeftBarActive === '2') {
        return this.dataList.shengao2
      } else if (this.shengaoLeftBarActive === '3') {
        return this.dataList.shengao3
      }
    },
    // 检查选项是否在输入框值中存在
    isItemInInputValue(item) {
      if (!this.inputValue || !item) {
        return false;
      }
      const itemText = typeof item === 'object' ? item.label : item;
      return this.inputValue.includes(itemText);
    }
  }
}
</script>

<style lang="less" scoped>
.selectPop{
  width: 100%;
  border-radius: 6px;
  background-color: #fff;
  border: 1px solid #e0e5ee;
  box-shadow: 0 3px 12px 2px rgba(0, 0, 0, .1);
  overflow: hidden;
  height: auto;
  display: flex;
  flex-direction: column;
  .content{
    width: 100%;
    border-radius: 6px;
    padding: 20px;
    overflow: hidden;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 10px; /* 恢复行之间的间距 */
    .rowBox{
      color: #7a8794;
      font-size: 12px;
      font-family: "微软雅黑";
      display: flex;
      flex-direction: column;
      border-bottom: 1px dashed #e0e5ee;
      &:nth-last-child(1) {
        border-bottom: none;
      }
      .rowItem{
        display: flex;
        align-items: flex-start; /* 顶部对齐，更适合有换行的情况 */
        padding-bottom: 10px; /* 恢复底部内边距 */
        height: auto; /* 自适应高度 */
        gap: 15px; /* 添加间距，确保同一行中的不同项目之间有一致的间距 */
        .itemTitle{
          font-weight: 700; /* 增加字体粗细 */
          font-size: 12px;
          font-family: "微软雅黑";
          color: #000;
          user-select: none;
          height: 24px; /* 固定高度 */
          display: flex;
          justify-content: flex-start; /* 左对齐 */
          align-items: center; /* 垂直居中 */
          padding: 0 2px 0 0; /* 减小右侧内边距 */
          margin-right: 0; /* 移除右侧外边距 */
          white-space: nowrap; /* 防止文字换行 */
          overflow: hidden; /* 防止文字溢出容器 */
          text-overflow: ellipsis; /* 文字溢出时显示省略号 */
        }
        .itemList{
          display: flex;
          flex-wrap: wrap;
          width: calc(100% - 70px); /* 减去itemTitle的宽度 */
          gap: 8px; /* 恢复items之间的间距 */
          margin-left: 0; /* 移除左侧外边距 */
          padding-right: 12px;

          &.no-title {
            width: 100%; /* 当没有标题时，使用全宽 */
            padding-left: 0; /* 没有标题时不需要左侧内边距 */
          }

          .items{
            cursor: pointer;
            user-select: none;
            height: 24px; /* 与itemTitle高度一致 */
            display: flex;
            align-items: center; /* 垂直居中 */
            padding: 0 5px; /* 水平内边距 */
            margin: 2px 0; /* 添加上下外边距 */
            &:hover {
              background-color: #e9f2fe;
              border-radius: 2px;
              color: #409eff;
            }
            &.highlight {
              color: #ff0000;
              font-weight: bold;
            }
          }

          /* 添加换行样式 */
          .line-break {
            flex-basis: 100%;
            height: 0px; /* 增加高度，提供更明显的间距 */
            margin: 0;
            padding: 0;
            overflow: hidden;
          }
        }
      }
    }
  }
  .closeBtn{
    height: 40px;
    width: 100%;
    color: #005ed9;
    background-color: #f5f7fb;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    i{
      font-size: 21px;
      line-height: 30px;
    }
    .text{
      margin-left: 2px;
      line-height: 40px;
      user-select: none;
    }
    &:hover{
      background-color: rgba(2,10,26,.04);
    }
  }
}
/deep/ .el-tabs__header{
  margin: 0 12px 0px;
}

.manyContent{
  display: flex;
  align-items: center;
  height: auto;
  .leftContent{
    height: 160px;
    width: 182px;
    //border: 1px solid red;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //padding-left: 10px;
    padding-left: 15px;
    margin-top: 20px;
    align-self: flex-start; /* 添加此行，使leftContent不参与manyContent的align-items: center */
    .contentItem{
      height: 32px;
      width: 100%;
      border-radius: 6px;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
      &:hover{
        background-color: #f2f4f7;
      }
    }
    .contentItemactive{
      height: 32px;
      width: 100%;
      border-radius: 6px;
      background-color: #e9f2fe;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
      &:hover{
        background-color: #f2f4f7;
      }
    }
  }
  .rightContent{
    padding-right: 20px;
    //border: 1px solid red;
    width: 180px;
    text-align: center;
    color: #aab4bf;
    font-size: 24px;

  }
}
</style>
